import { useNavigate } from "react-router-dom";
import { useUserServices } from "../../context/DealerProfile";
import { Button, Textarea } from "flowbite-react";
// import { usePurchaseOrder } from "./hooks/usePurchaseOrder";

const PurchaseInformation = ({
  formData,
  handleInputChange,
  onlyInfo = false,
  isReturn,
}) => {
  const {
    dealerDetail: { billingAddresses, inHouseShipping, endCustomerShipping, parentAccount },
  } = useUserServices();
  // const { billingAddresses: billingAddressesId } = usePurchaseOrder();
  const shippingOptions =
    formData?.whichTypeShipping === "in"
      ? inHouseShipping
      : endCustomerShipping;
    
      
  // console.log("HERE ---> : ", shippingOptions);
  
console.log({dealerDetail: { billingAddresses, inHouseShipping, endCustomerShipping, parentAccount }});
  const navigate = useNavigate(); // Get navigate function
  // console.log({ formData });
  const handleAddAddressClick = ({ isBilling }) => {
    const baseUrl = isBilling ? `/${isBilling}` : "/shipping-adresses"; // Base URL for shipping addresses
    const queryParams = new URLSearchParams();
  
    // Check which type of shipping is selected
    queryParams.set("query", "create");

    if (formData.whichTypeShipping === "in" || isBilling)
      queryParams.set("customerType", "inHouse");
    else queryParams.set("customerType", "endCustomer");

    // Get current URL and remove "/app" from it
    const currentUrl = window.location.pathname.replace("/app", "");
    queryParams.set("history", currentUrl);

    // Navigate to the constructed URL with query parameters
    console.log({ url: `${baseUrl}?${queryParams.toString()}` });
    navigate(`${baseUrl}?${queryParams.toString()}`);
  };

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">
        {isReturn ? "Return Information" : "Purchase Information"}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Show Current Date and Stage when onlyInfo is true */}
        {onlyInfo && (
          <>
            <div>
              <label className="label">
                {!isReturn ? "CP Purchase Number" : "Return Number"}
              </label>
              <input
                onChange={() => { }}
                type="text"
                value={formData?.Name}
                readOnly={onlyInfo}
                className="input input-bordered w-full cursor-not-allowed"
              />
            </div>
            <div>
              <label className="label">Date</label>
              <input
                required={true}
                readOnly={onlyInfo}
                id="Delivery_Date"
                type="date"
                className={`input input-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                  }`}
                value={new Date(
                  formData?.Created_Time ?? formData?.Sales_Return_Date
                )
                  .toISOString()
                  .slice(0, 10)} // Format date to "YYYY-MM-DD"
                onChange={(e) => { }}
              />
            </div>
            <div>
              <label className="label">{isReturn ? "Status" : "Stage"}</label>
              <input
                onChange={() => { }}
                type="text"
                value={isReturn ? formData?.Return_Status : formData?.Stage}
                readOnly={onlyInfo}
                className="input input-bordered w-full cursor-not-allowed"
              />
            </div>
            <div>
              <label className="label">PO Number</label>
              <input
                onChange={() => { }}
                type="text"
                value={
                  isReturn
                    ? formData?.CP_Purchase?.name
                    : formData?.Customer_PO_No
                }
                readOnly={onlyInfo}
                className="input input-bordered w-full cursor-not-allowed"
              />
            </div>
          </>
        )}

        {/* Delivery Date Picker */}
        {!isReturn && (
          <>
            <div>
              <label htmlFor="Delivery_Date" className="label">
                Delivery Date
              </label>
              <input
                readOnly={onlyInfo}
                id="Delivery_Date"
                type="date"
                className={`input input-bordered w-full ${onlyInfo
                    ? `${formData?.Old_Delivery_Date !== formData?.Delivery_Date
                      ? "bg-red-400 text-white"
                      : "bg-gray-300 text-gray-600"
                    } cursor-not-allowed`
                    : ""
                  }`}
                value={formData?.Delivery_Date}
                onChange={(e) =>
                  handleInputChange("Delivery_Date", e.target.value)
                }
                min={new Date().toISOString().split("T")[0]}
                old={formData?.Old_Delivery_Date}
                onClick={(e) => !onlyInfo && e?.target?.showPicker()}
              />
            </div>

            <div>
              {/* Request Type */}
              <label htmlFor="Request_Type" className="label">
                Select Request Type
              </label>
              {onlyInfo ? (
                <input
                  readOnly={onlyInfo}
                  id="Request_Type"
                  className={`input input-bordered w-full`}
                  value={formData?.Request_Type}
                  min={new Date().toISOString().split("T")[0]}
                />
              ) : (
                <select
                  // required={true}
                  readOnly={onlyInfo}
                  id="Request_Type"
                  className={`select select-bordered w-full ${onlyInfo
                      ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                      : ""
                    }`}
                  value={formData?.Request_Type}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    handleInputChange("Request_Type", newValue);

                    if (newValue === "Dropship") {
                      handleInputChange("whichTypeShipping", "end");
                    }
                  }}
                >
                  {onlyInfo && <option value="" disabled></option>}
                  <option value="Stock">Stock</option>
                  <option value="Sample">Sample</option>
                  <option value="Dropship">Dropship</option>
                </select>
              )}
            </div>
          </>
        )}

        {!onlyInfo && (
          <div>
            <label htmlFor="billingAddresses" className="label">
              Select Billing Address
              {!isReturn && (
                <Button
                  onClick={() =>
                    handleAddAddressClick({ isBilling: "billing-adresses" })
                  }
                  size="xs"
                >
                  Add Address
                </Button>
              )}

            </label>
            {isReturn ? (
              <input
                id="billingAddresses"
                className={`select select-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                  }`}
                value={
                  billingAddresses.find((address) => address.id === formData?.billingAddresses)
                    ? billingAddresses.find((address) => address.id === formData?.billingAddresses).Company_Name
                    : ""
                }
                onChange={(e) => handleInputChange("billingAddresses", e.target.value)}
                readOnly
              />
            ) : (
              <select
                readOnly={onlyInfo}
                id="billingAddresses"
                className={`select select-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                  }`}
                value={formData?.billingAddresses}
                onChange={(e) => handleInputChange("billingAddresses", e.target.value)}
              >
                <option value="" disabled>
                  Select Billing Address
                </option>
                {billingAddresses.map((address) => (
                  <option key={address.id} value={address.id}>
                    {address.Company_Name}
                  </option>
                ))}
              </select>
            )}


          </div>
        )}

        {!onlyInfo && (
          <div>
            <label htmlFor="whichTypeShipping" className="label">
              {isReturn ? "Pick Up Type" : "Delivery Type"}
            </label>
            <select
              // required={true}
              readOnly={onlyInfo}
              id="whichTypeShipping"
              className={`select select-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                }`}
              value={formData?.whichTypeShipping}
              onChange={(e) =>
                handleInputChange("whichTypeShipping", e.target.value)
              }
            >
              <option value="" disabled>
                {isReturn ? "Select Pick Up Type" : "Select Delivery Type"}
              </option>
              <option value="in">Channel Partner Warehouse</option>
              <option value="end">End Customer</option>
            </select>
          </div>
        )}

        {!onlyInfo && (
          <div>
            <label htmlFor="shippingAddress" className="label">
              {isReturn ? "Select Pick Up Information" : "Select Shipping Address"} 
              <Button onClick={handleAddAddressClick} size="xs">
                Add Address
              </Button>
            </label>
            <select
              readOnly={onlyInfo}
              id="shippingAddress"
              className={`select select-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                }`}
              value={
                formData?.whichTypeShipping === "in"
                  ? formData?.inHouseShipping
                  : formData?.endCustomerShipping
              }
              onChange={(e) =>
                handleInputChange(
                  formData?.whichTypeShipping === "in"
                    ? "inHouseShipping"
                    : "endCustomerShipping",
                  e.target.value
                )
              }
            >
              <option value="" disabled>
              {isReturn ? "Select Pick Up Information" : "Select Shipping Address"}
              </option>
              {shippingOptions.map((address) => (
                <option key={address.id} value={address.id}>
                  {address.Company_Name + (address.End_Customer?.name ? ` - ${address.End_Customer.name}` : '')}
                </option>
              ))}
            </select>
          </div>
        )}

        {isReturn && (
          <>
            <div>

              <label htmlFor="returnReason" className="label">
                Reason
              </label>
              <select
                // required={true}
                id="returnReason"
                className={`select select-bordered w-full ${onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                  }`}
                value={formData?.returnReason ?? formData?.Return_Description}
                onChange={(e) =>
                  handleInputChange("returnReason", e.target.value)
                }
                readOnly={onlyInfo}
              // disabled={onlyInfo}
              >
                <option value="" disabled>
                  Select Return Reason
                </option>
                <option value="Damaged">Damaged</option>
                <option value="Incorrect Item">Incorrect Item</option>
                <option value="Quality Issue">Quality Issue</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <label className="label">Return Description</label>
              <Textarea
                name="returnDescription"
                readOnly={onlyInfo}
                id="returnDescription"
                className={`w-full`}
                // onlyInfo ? "bg-gray-300 text-gray-600 cursor-not-allowed" : ""
                value={
                  formData?.returnDescription ?? formData?.Return_Description
                }
                onChange={(e) =>
                  handleInputChange("returnDescription", e.target.value)
                }
                rows={4}
              ></Textarea>
            </div>
          </>
        )}

        {/* ------------------------------- */}
      </div>
    </div>
  );
};

export default PurchaseInformation;
